import { styled } from '@mui/material/styles';
import { DoughnutChartSkeleton } from './DoughnutChartSkeleton';
import Skeleton from '@mui/material/Skeleton';
import { DoughnutLayout } from './DoughnutLayout';
const DoughnutChartCardSkeletonList = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(8),
  width: '100%',
  padding: 0,
}));

const DoughnutChartCardSkeletonEntry = styled(Skeleton)(({ theme }) => ({
  width: '100%',
  height: theme.spacing(20),
}));

export const DoughnutChartCardSkeleton = () => {
  return (
    <DoughnutLayout
      chart={<DoughnutChartSkeleton />}
      legend={
        <DoughnutChartCardSkeletonList>
          <DoughnutChartCardSkeletonEntry />
          <DoughnutChartCardSkeletonEntry />
          <DoughnutChartCardSkeletonEntry />
        </DoughnutChartCardSkeletonList>
      }
    />
  );
};
